import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface CommonRadioButtonItem {
  name: string;
  value: number | string | boolean;
  disabled?: boolean;
}

@Component({
  selector: 'common-radio-group',
  templateUrl: './common-radio-group.component.html',
  styleUrls: ['./common-radio-group.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CommonRadioGroupComponent),
    },
  ],
})
export class CommonRadioGroupComponent implements ControlValueAccessor {
  @Input() groupId = 'radioGroup';
  @Input() items: CommonRadioButtonItem[] = [];
  @Input() uncheckedButtonClass = 'form-control';
  @Input() checkedButtonClass = 'form-control';
  @Input() indentation = false;
  @Input() width?: string;
  @Input() minButtonWidthPx = 35;

  radioValue: number | string = '';

  private touched = false;
  private onChangeMethod: (value: number | string | boolean) => unknown;
  private onTouchedMethod: () => unknown;

  registerOnChange(onChangeMethod: () => unknown): void {
    this.onChangeMethod = onChangeMethod;
  }

  registerOnTouched(onTouchedMethod: () => unknown): void {
    this.onTouchedMethod = onTouchedMethod;
  }

  writeValue(value: number | string | null): void {
    this.radioValue = value;
  }

  onChange(newValue: number | string | boolean): void {
    this.markAsTouched();
    this.onChangeMethod(newValue);
  }

  private markAsTouched(): void {
    if (this.touched) {
      return;
    }

    this.touched = true;
    this.onTouchedMethod();
  }
}
